import { fetchAuthSession } from 'aws-amplify/auth';

const API_BASE = process.env.REACT_APP_API_URL;

// Cognito ID トークンを取得する（API Gateway JWT Authorizer が検証する）
const getToken = async () => {
  const { tokens } = await fetchAuthSession();
  return tokens?.idToken?.toString() ?? null;
};

const request = async (method, path, { params, body } = {}) => {
  const token = await getToken();
  const url = new URL(`${API_BASE}${path}`);
  if (params) {
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null) url.searchParams.set(k, String(v));
    });
  }
  const res = await fetch(url.toString(), {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  });
  if (!res.ok) {
    const text = await res.text();
    const err = new Error(text || res.statusText);
    err.status = res.status;
    throw err;
  }
  return res.json();
};

export const api = {
  get:    (path, params)  => request('GET',    path, { params }),
  post:   (path, body)    => request('POST',   path, { body }),
  put:    (path, body)    => request('PUT',    path, { body }),
  patch:  (path, body)    => request('PATCH',  path, { body }),
  delete: (path, params)  => request('DELETE', path, { params }),
};
